'use client'

import classNames from 'classnames'
import CTAContactLink from './CTAContactLink'
import FloatingCTALazy from './FloatingCTALazy'
import { useHideNearTargets } from './useHideNearTargets'

/**
 * Sammelstelle der schwebenden Aktionen unten rechts.
 *
 * Mobil liegen Kontakt-Tab und Beratungs-Button in einer Reihe nebeneinander,
 * statt als zwei einzelne fixierte Elemente uebereinander. Ab lg loest sich der
 * Rahmen per display:contents wieder auf, dann positioniert sich jedes Kind
 * selbst: der Tab am rechten Rand auf halber Hoehe, die Beratung unten rechts.
 *
 * Der has-Selektor faengt den dritten Zustand ab: sobald die Beratung als
 * Leiste am unteren Rand offen ist (data-consult-bar, fixed bottom-0, rund
 * 130px hoch), rueckt die Reihe darueber. Der runde Button existiert in diesem
 * Zustand nicht, in der Reihe steht dann nur der Tab.
 *
 * Unter lg tritt die ganze Reihe samt Leiste zurueck, solange das
 * Anfrageformular oder ein Kalender im Bild ist (useHideNearTargets). Sonst
 * liegen Pille und Leiste ueber "Anfrage absenden". Die Verschiebung sitzt
 * nur auf Pille und rundem Button, nicht auf dem Rahmen: ein translate am
 * Rahmen wuerde ihn zum Bezugsrahmen der fixierten Leiste machen, die dann
 * waehrend des Ausblendens an die Pille springt.
 */
const FloatingActions = ({ withConsultation = false }: { withConsultation?: boolean }) => {
  const hidden = useHideNearTargets()

  return (
    <div
      data-floating-hidden={hidden || undefined}
      className={classNames(
        'fixed right-8 bottom-8 z-45 flex items-center gap-3 has-[[data-consult-bar]]:bottom-40 lg:contents',
        'max-lg:transition-opacity max-lg:duration-200 max-lg:[&>a]:transition-[translate,color,background-color] max-lg:[&>a]:duration-200 max-lg:[&>button]:transition-[translate,opacity,background-color] max-lg:[&>button]:duration-200',
        hidden && 'max-lg:pointer-events-none max-lg:opacity-0 max-lg:motion-safe:[&>a]:translate-y-4 max-lg:motion-safe:[&>button]:translate-y-4'
      )}
    >
      <CTAContactLink />
      {withConsultation && <FloatingCTALazy />}
    </div>
  )
}

export default FloatingActions
